import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SERVICES } from '../../data/services.data';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly services = SERVICES;
  isMenuOpen = false;
  servicesMenuClosed = false;

  // hover/focus keep the CSS dropdown open after navigating, so hide it
  // until the pointer leaves the Services item
  closeServicesMenu(event: Event) {
    this.servicesMenuClosed = true;
    (event.currentTarget as HTMLElement | null)?.blur();
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
  }

  closeMenu() {
    this.isMenuOpen = false;
    document.body.style.overflow = '';
  }
}
